var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getHash, getVersion } from './env';
import { getLanguageData } from '../i18n/locales/info';
function mapAcceptLanguage(locale) {
    var _a, _b;
    return (_b = (_a = getLanguageData(locale)) === null || _a === void 0 ? void 0 : _a.acceptLanguage) !== null && _b !== void 0 ? _b : locale;
}
const defaultWebgateHeaders = {
    accept: 'application/json',
    'content-type': 'application/json',
    'spotify-app-version': `${getVersion()}.${getHash()}`.trim(),
    'app-platform': 'Browser',
    'accept-language': mapAcceptLanguage((typeof document === 'object' && document.documentElement.lang) || 'en'),
};
export const WEBGATE_DOMAIN = `https://generic.wg.spotify.com`;
export function webgateFetch(input, token) {
    return __awaiter(this, void 0, void 0, function* () {
        const req = new Request(input, {
            headers: defaultWebgateHeaders,
        });
        if (token) {
            req.headers.set('authorization', `Bearer ${token}`);
        }
        return fetch(req);
    });
}
//# sourceMappingURL=webgate-fetch.js.map